import { observable, action } from 'mobx';
import Config from '~domain/entities/Config/Config';
import { ICartServiceConfig } from '~domain/entities/Config/IConfig';

export default class ConfigStore {
    @observable public config: Config;

    constructor(config: ICartServiceConfig) {
        this.updateConfig(config);
    }

    @action
    public updateConfig(config: ICartServiceConfig) {
        // @ts-ignore
        this.config = { ...this.config, ...config };
    }
}
